module.exports = __webpack_public_path__ + "static/media/icon-financial.fd00535a.svg";